<ion-header class="modal-header">
  <div class="modal-title">
    <h3>Connect Jira Service Management</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        shape="round"
        class="close-button"
        (click)="dismiss()"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card style="margin: 15px">
    <ion-card-content>
      <ion-label class="input-label">Jira Site Name *</ion-label>
      <ion-input
        [(ngModel)]="instanceName"
        placeholder="your-site-name"
        (keyup.enter)="submit()"
        class="input-field"
      ></ion-input>
      <ion-note style="display: block; margin-top: 8px; font-size: 0.85rem">
        Enter your site name (e.g., "unthreadapp" for unthreadapp.atlassian.net)
      </ion-note>
    </ion-card-content>
  </ion-card>
</ion-content>

<ion-footer class="footer">
  <ion-button
    (click)="submit()"
    [disabled]="!instanceName?.trim()"
    style="margin: 15px"
  >
    Connect
  </ion-button>
</ion-footer>
